import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito tener una propiedad propia?',
  a: 'No. El modelo se basa en gestionar propiedades de terceros. El Tomo 1 explica el arbitraje de gestión desde cero.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en PDF. Acceso por email en menos de 5 minutos después del pago.'
}, {
  q: '¿Sirve si estoy en el interior del país?',
  a: 'Sí. Diseñado para cualquier ciudad argentina con demanda turística o de negocios.'
}, {
  q: '¿Funciona si nunca gestioné una propiedad?',
  a: 'Es exactamente para eso. El Bono 6 te da el plan diario para conseguir tu primera propiedad esta semana.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, 100% de devolución. Escribís a soporteiterapro@gmail.com y listo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-surface" data-id="element-78">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-79">
        <div className="text-center mb-12" data-id="element-80">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-81">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-84">
                <span className="font-bold text-gray-900 pr-4" data-id="element-85">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-200 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>
              <AnimatePresence data-id="element-87">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-88">
                    <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed border-t border-gray-50 pt-4" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}